import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _excluded = ["team", "team_role"];
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Model, referenceOne } from 'libx';
import { observable, computed } from 'mobx';
import moment from 'moment';
import flatten from 'lodash/flatten';
import { camelizeKeys } from '../utils/objectUtil';

/**
 * A member of a team.
 */
var TeamMember = (_class = /*#__PURE__*/function (_Model) {
  function TeamMember() {
    var _this;
    _classCallCheck(this, TeamMember);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, TeamMember, [].concat(args));
    /**
     * ID of the workspace this member belongs to.
     */
    _initializerDefineProperty(_this, "workspaceId", _descriptor, _this);
    /**
     * ID of the team this member belongs to.
     */
    _initializerDefineProperty(_this, "teamId", _descriptor2, _this);
    /**
     * The actual user ID.
     */
    _initializerDefineProperty(_this, "userId", _descriptor3, _this);
    /**
     * The user public ID.
     */
    _initializerDefineProperty(_this, "userPublicId", _descriptor4, _this);
    /**
     * If `true`, the user cannot use the platform.
     */
    _initializerDefineProperty(_this, "inactive", _descriptor5, _this);
    /**
     * The id of the team role
     */
    _initializerDefineProperty(_this, "teamRoleId", _descriptor6, _this);
    return _this;
  }
  _inherits(TeamMember, _Model);
  return _createClass(TeamMember, [{
    key: "computedPermissions",
    get:
    /**
     * To mimic Member API
     */
    function get() {
      return this.teamRole ? this.teamRole.permissions : {};
    }

    /**
     * Gets the workspace member that backs this team member.
     */
  }, {
    key: "member",
    get: function get() {
      return this.rootStore.memberStore.forWorkspaceAndUserPublicId(this.workspaceId, this.userPublicId);
    }

    /**
     * Team reference.
     */
  }, {
    key: "team",
    get: function get() {
      return referenceOne(this.rootStore.teamStore.teams, this.teamId);
    }

    /**
     * Determines if this member is the team owner.
     */
  }, {
    key: "isTeamOwner",
    get: function get() {
      return !!this.team && this.team.ownerPublicId === this.userPublicId;
    }

    /**
     * Team role reference.
     */
  }, {
    key: "teamRole",
    get: function get() {
      return referenceOne(this.rootStore.teamRoleStore.teamRoles, this.teamRoleId);
    }
  }, {
    key: "hasAllPermissions",
    value: function hasAllPermissions() {
      var _this2 = this;
      for (var _len2 = arguments.length, ids = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        ids[_key2] = arguments[_key2];
      }
      ids = flatten(ids);
      if (ids.length === 0) return true;
      return ids.every(function (id) {
        return _this2.hasPermission(id);
      });
    }
  }, {
    key: "hasSomePermissions",
    value: function hasSomePermissions() {
      var _this3 = this;
      for (var _len3 = arguments.length, ids = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        ids[_key3] = arguments[_key3];
      }
      ids = flatten(ids);
      if (ids.length === 0) return true;
      return ids.some(function (id) {
        return _this3.hasPermission(id);
      });
    }
  }, {
    key: "hasPermission",
    value: function hasPermission(id) {
      var computedPerms = this.computedPermissions || {};
      return computedPerms[id] === 'allow' && this.rootStore.permissionStore.isFeatureEnabledForPermission(id);
    }

    /**
     * Parses the props.
     *
     * @param {*} json
     */
  }, {
    key: "parse",
    value: function parse(_ref) {
      var team = _ref.team,
        team_role = _ref.team_role,
        json = _objectWithoutProperties(_ref, _excluded);
      if (json.workspace_id && json.user_id && json.user_public_id) {
        this.rootStore.memberStore.setAndFetch({
          workspace_id: json.workspace_id,
          user_id: json.user_id,
          user_public_id: json.user_public_id
        });
      }
      if (team) {
        this.rootStore.teamStore.teams.set(team);
      }
      if (team_role) {
        this.rootStore.teamRoleStore.teamRoles.set(team_role);
      }
      return _objectSpread(_objectSpread({}, camelizeKeys(json)), {}, {
        teamId: team ? team.id : json.team_id,
        dateCreated: json.date_created && moment(json.date_created),
        dateModified: json.date_modified && moment(json.date_modified)
      });
    }
  }]);
}(Model), _descriptor = _applyDecoratedDescriptor(_class.prototype, "workspaceId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "teamId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "userId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "userPublicId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "inactive", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "teamRoleId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _applyDecoratedDescriptor(_class.prototype, "computedPermissions", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "computedPermissions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "member", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "member"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "team", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "team"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isTeamOwner", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isTeamOwner"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "teamRole", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "teamRole"), _class.prototype), _class);
export { TeamMember as default };
//# sourceMappingURL=TeamMember.js.map
